module.exports = __webpack_public_path__ + "img/sprite-categories.e119d81.svg";